const DEFLY_WALLET_MODAL_STYLES = {
  position: "absolute",
  "max-width": "var(--widget-width)",
  height: "var(--widget-height)",
  overflow: "hidden",
  "border-radius": "var(--container-border-radius)",
  "background-color": "var(--overlay)"
};

const DEFLY_WALLET_MODAL_BODY_STYLES = {
  top: "unset",
  bottom: "0",
  left: "0",
  margin: "4px",
  animation: "none",
  position: "absolute",
  width: "100%",
  "max-width": "calc(100% - 8px)",
  "max-height": "400px",
  "overflow-y": "auto",
  "border-radius": "20px"
};

const DEFLY_WALLET_MODAL_BODY_HEADER_STYLES = {
  top: "12px",
  padding: "0 12px",
  "justify-content": "flex-end",
  "z-index": "4"
};

const DEFLY_WALLET_MODAL_BODY_HEADER_CLOSE_BUTTON_STYLES = {
  border: "unset",
  background: "transparent",
  width: "24px",
  height: "24px"
};

export {
  DEFLY_WALLET_MODAL_STYLES,
  DEFLY_WALLET_MODAL_BODY_STYLES,
  DEFLY_WALLET_MODAL_BODY_HEADER_STYLES,
  DEFLY_WALLET_MODAL_BODY_HEADER_CLOSE_BUTTON_STYLES
};
